export const LOGIN = {
    emailInput: 'login-email-input',
    passwordInput: 'login-password-input',
    submitButton: 'login-submit-button',
    googleButton: 'login-google-button',
    registerLink: 'login-register-link',
    forgotPasswordLink: 'login-forgot-password-link',
    errorAlert: 'login-error-alert',
};

export const FORGOT_PASSWORD = {
    page: 'forgot-password-page',
    emailInput: 'forgot-password-email-input',
    submitButton: 'forgot-password-submit-button',
    confirmationMessage: 'forgot-password-confirmation',
    backToLogin: 'forgot-password-back-link',
    errorAlert: 'forgot-password-error-alert',
};

export const RESET_PASSWORD = {
    page: 'reset-password-page',
    passwordInput: 'reset-password-new-input',
    confirmInput: 'reset-password-confirm-input',
    submitButton: 'reset-password-submit-button',
    errorAlert: 'reset-password-error-alert',
    invalidTokenMessage: 'reset-password-invalid-token',
};

export const REGISTER = {
    nameInput: 'register-name-input',
    emailInput: 'register-email-input',
    passwordInput: 'register-password-input',
    submitButton: 'register-submit-button',
    googleButton: 'register-google-button',
    loginLink: 'register-login-link',
    errorAlert: 'register-error-alert',
};

export const LOGOUT = {
    button: 'logout-button',
    menuTrigger: 'user-menu-trigger',
};
